var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplosion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 106,
    viewBox: "0 0 104 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7692 31.8297L41.4237 4.62982L37.1299 27.0295L19.4484 0.790039L25.5107 33.4291L0 31.5089L21.4692 52.3072L9.09179 64.4671L24.7521 66.3866L19.4472 94.5469L37.6338 76.9473L43.6962 105.425L49.7573 73.7465L60.3661 93.2649L61.3762 72.7861L88.6546 97.4242L75.7735 65.7455L95.475 63.826L80.824 51.0267L103.556 33.4276L75.2671 37.907L82.593 14.2274L68.9543 29.9068L63.9013 1.10937L50.7692 31.8297Z",
    fill: "#DB0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosion);
export default __webpack_public_path__ + "static/media/explosion.116603567522382e05e1e4e49f9cc8ae.svg";
export { ForwardRef as ReactComponent };